import React from 'react';

function Skuld() {
  return (
    <div>
      “That which is owed”
    </div>
  );
}

export default Skuld;